<template>
	<div :class="design">
		<div class="card" :class="cardClass">
			<div class="header">
				<div v-show="sortable" class="sort">
					<i class="fal fa-sort"></i>
				</div>

				<div class="title">{{ title }}</div>

				<div v-show="!noPermissions" class="permissions">
					<div class="permission entry" :class="entryClass">E</div>
					<div class="permission exit" :class="exitClass">S</div>
				</div>

				<div class="buttons">
					<ui-menu-card v-if="!$mx_userIsCollaborator">
						<button
							v-for="(menu, index) in menuOptions"
							:key="`${index}-${menu.label}`"
							type="button"
							@click="handleAction(menu.action)"
						>
							{{ menu.label }}
						</button>
					</ui-menu-card>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { uiMenuCard } from '@/components/ui'

	import { permissionsMixin } from '@/mixins'

	export default {
		name: 'status-card',

		components: {
			uiMenuCard,
		},

		mixins: [permissionsMixin],

		props: {
			/**
			 * Propriedade: title
			 * Recebe o título do componente.
			 */
			title: {
				type: String,
				required: true,
			},

			/**
			 * Propriedade: objectData
			 * Recebe um objeto que será retornado nos eventos.
			 */
			objectData: {
				type: Object,
				required: true,
			},

			/**
			 * Propriedade: sortable
			 * Define se o componente será ordenável.
			 */
			sortable: {
				type: Boolean,
				default: false,
			},

			/**
			 * Propriedades: entry, exit
			 * Define se há permissão de entrada e saida.
			 */
			entry: {
				type: Boolean,
				default: false,
			},

			exit: {
				type: Boolean,
				default: false,
			},

			/**
			 * Propriedades: noPermissions
			 * Desativa os icones de permissão.
			 */

			noPermissions: {
				type: Boolean,
				default: false,
			},

			/**
			 * Propriedades modificadoras de estilo.
			 */

			design: {
				type: String,
				default: '',
			},

			resetCss: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				options: [
					{
						active: true,
						action: '-edit',
						label: 'Editar Status',
					},
				],
			}
		},

		computed: {
			cardClass() {
				return {
					reset: this.resetCss,
				}
			},

			menuOptions() {
				return this.options.filter((item) => item.active)
			},

			entryClass() {
				return [this.entry ? 'active' : 'block']
			},

			exitClass() {
				return [this.exit ? 'active' : 'block']
			},
		},

		methods: {
			handleAction(action) {
				if (this.$mx_userIsCollaborator) return

				this.$emit('status-card' + action, this.objectData)
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
